module.exports = __webpack_public_path__ + "img/heart-filled.2cae07ae.svg";